import React from 'react';
import { Route } from 'react-router';
import Family from '../../components/Pages/Family';


const routes = <Route path="family" component={Family.LandingPage} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/family.js